import { render, staticRenderFns } from "./ArticleCardSkeleton.vue?vue&type=template&id=a935f34c&scoped=true&"
import script from "./ArticleCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./ArticleCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCardSkeleton.vue?vue&type=style&index=0&id=a935f34c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a935f34c",
  null
  
)

export default component.exports